import req from "../http";

const rpa = {
  // 取得 RPA狀態
  getRPAStatus() {
    return req("get", "/RPA/Enabled");
  },

  // 變更 RPA狀態
  putRPAStatus(params) {
    return req("put", "/RPA/Enabled", params);
  },

  // 取得 Email同步履歷 收信參數
  getEmailSetting() {
    return req("get", "/RPA/SyncEmailSetting");
  },

  // 變更 Email同步履歷 收信參數
  putEmailSetting(params) {
    return req("put", "/RPA/SyncEmailSetting", params);
  },
};

export default rpa;